<template>
   <div class="history_container">
        <div v-if="items.length > 0">
            <div class="item_container" v-for="(item, index) in items" :key="index">
                <div class="item_header">
                    <span class="item_user"><i class="fa fa-user"></i> {{ item.usuario }}</span>
                    <span class="item_date">{{ item.fecha }}</span>
                </div>
                <div class="item_body" v-html="item.descripcion"></div>
            </div>
        </div>
        <div v-else class="alert alert-info" role="alert">
            No hay registros
        </div>
   </div>
</template>

<script>
import axios from 'axios';


export default {
    name: "history-compliance",
    props: {
        data: {
            required: true,
            type: Object
        }
    },
	data () {
        return {
            items: []
        }
    },
	methods: {
        getComplianceHistory: function (data) {
            axios.get(`/compliance/history/${data.id}`).then((response) => {
                this.items = response.data;
            });
        }
    },
    created() {
        this.getComplianceHistory(this.data);
    },
}

</script>

<style scoped>
    .item_container {
        background-color: #fff;
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 10px;
    }
    .item_header{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .item_body {
        margin-top: 10px;
    }

    .item_date {
        color: #999;
        font-size: 12px;
    }

    .item_user {
        font-weight: bold;
    }
    
</style>
